var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#232832"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1667 22.1843V27.1667C29.1667 28.2713 28.2712 29.1667 27.1667 29.1667H17.8333C16.7288 29.1667 15.8333 28.2713 15.8333 27.1667V22.1843M18.75 20.625C18.75 21.6606 17.9105 22.5 16.875 22.5C15.9263 22.5 15.1421 21.7954 15.0173 20.881C14.9943 20.7122 15.0218 20.5416 15.0648 20.3768L15.86 17.3285C16.0897 16.4479 16.8851 15.8334 17.7952 15.8334H27.2048C28.1149 15.8334 28.9103 16.4479 29.14 17.3285L29.9352 20.3768C29.9782 20.5416 30.0057 20.7122 29.9827 20.881C29.8579 21.7954 29.0737 22.5 28.125 22.5C27.0895 22.5 26.25 21.6606 26.25 20.625M18.75 20.625C18.75 21.6606 19.5895 22.5 20.625 22.5C21.6605 22.5 22.5 21.6606 22.5 20.625M18.75 20.625L19.1667 15.8334M22.5 20.625C22.5 21.6606 23.3395 22.5 24.375 22.5C25.4105 22.5 26.25 21.6606 26.25 20.625M22.5 20.625V15.8334M26.25 20.625L25.8333 15.8334",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderStore);
export default __webpack_public_path__ + "static/media/order-store.7261d2f36cc6e7a9d78850574ee965a5.svg";
export { ForwardRef as ReactComponent };